import { render } from "./todo.vue?vue&type=template&id=104a9b14"
import script from "./todo.vue?vue&type=script&lang=js"
export * from "./todo.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Project\\crosstechno\\crm-frontend-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__